import packageJson from '../../package.json';

export const environment = {
  production: false,
  hmr: false,
  appConfig: 'appconfig.dev.json',
  version: packageJson.version
};
